import { Component } from "@angular/core"

import { EventService } from "../../services/event"

@Component({
  selector: "events-page",
  templateUrl: "index.html",
})
export class EventsPage {

  viewOption = "next"
  nextEvents = []
  eventsExchange = []

  constructor(
    private eventService: EventService
  ) {

    this.nextEvents = this.eventService.getNextEvents()
    this.eventsExchange = this.eventService.getEventExchanges()
  }
}



// WEBPACK FOOTER //
// ./src/pages/events/index.ts